import { Card, Tab, Tabs } from "react-bootstrap";
import DataTable from "react-data-table-component";
import React, { useState, useEffect, useContext } from "react";
import { getOrdersByBuyerId } from "../../../../api/order/orderApi";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../pages/ExtraPages/AuthProvider";
const TabExample = () => {
  const [key, setKey] = useState("all");

  const [orders, setOrders] = useState([]); // State to store fetched orders
  const { user } = useContext(AuthContext); // Use AuthContext to get user
  const [userId, setUserId] = useState(null); // Dynamic userId

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await getOrdersByBuyerId(userId);
        const data = response.data.data;

        console.log('order data', data);

        setOrders(data); // Store fetched orders in state
      } catch (error) {
        console.error("Error fetching orders data:", error);
      } finally {
        // Set loading to false once data is fetched
      }
    };

    if (userId) {
      fetchOrders();
    }
  }, [userId]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => index + 1, // Row number
      sortable: false,
      width: 'auto',
    },
    {
      name: 'Name',
      selector: (row) => row.Product_Name,
      sortable: true,
    },
    {
      name: 'Quantity',
      selector: (row) => row.quantity,
      sortable: true,
      left: true,
    },

    {
      name: 'Total Price',
      selector: (row) => row.Price_per_Kg,
      sortable: true,
      left: true,
      //format: row => `$${row?.Price_per_Kg.toFixed(2)}`,
    },
    {
      name: 'Order Date',
      selector: (row) => row.Order_Date,
      sortable: true,
      format: (row) =>
        new Date(row.Order_Date).toISOString().slice(0, 19).replace('T', ' '),
    },
    {
      name: 'Status',
      selector: (row) => row.Status,
      sortable: true,
      cell: (row) => (
        <span
          className={`status text-center ${
            row.status === 'Status' ? 'ToPay' : 'pending'
          }`}
        >
          {row.Status}
        </span>
      ),
    },
    {
      name: 'Action',
      cell: (row) => (
        <button
          onClick={() => handleAction(row)}
          className="tracking-button"
        >
          Track
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  //"/ordertracking/:id",

  const data = [
    {
      id: 1,
      productName: "Fresh Tuna",
      quantity: 10,

      totalPrice: 25.5,
      orderDate: "2024-02-12",
      status: "Completed",
    },
    {
      id: 2,
      productName: "Salmon Fillet",
      quantity: 5,

      totalPrice: 18.5,
      orderDate: "2024-02-11",
      status: "Pending",
    },
  ];

  const navigate = useNavigate();

  const handleAction = (row) => {

    navigate(`/ordertracking/${row._id}/${row.stock_number}/${row.trip_id}`); // Assuming 'id' exists in the row object

  };

  return (
    <Card>
      <Card.Body>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>Order History</h4>
          <div className="tab-container">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3"
            >
              <Tab eventKey="all" title="All" className="tab-link" />
              <Tab
                eventKey="processing"
                title="Processing"
                className="tab-link"
              />
              <Tab eventKey="shipped" title="Shipped" className="tab-link" />
              <Tab
                eventKey="delivered"
                title="Delivered"
                className="tab-link"
              />
            </Tabs>
          </div>
        </div>

        {/* Tab content based on active tab */}
        {key === "all" && (
          <div>
            <div style={{ padding: "20px" }}>
              <DataTable
                columns={columns}
                data={orders}
                pagination
                highlightOnHover
                responsive
              />
            </div>
          </div>
        )}
        {key === "processing" && <div>Orders being processed.</div>}
        {key === "shipped" && <div>Orders that have been shipped.</div>}
        {key === "delivered" && <div>Orders that have been delivered.</div>}
      </Card.Body>
    </Card>
  );
};

export default TabExample;
